export default "__VITE_ASSET__B4bPJ$BL__"